{
  "version": 1,
  "asset_id": "e1139dcd-8eb6-4c17-a8b8-e2f7d2148ecd",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e1139dcd-8eb6-4c17-a8b8-e2f7d2148ecd/hiatal-type-3-es-v3-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e1139dcd-8eb6-4c17-a8b8-e2f7d2148ecd/hiatal-type-3-es-v3-1200.jpg",
  "original_filename": "hiatal-type-3-es-v3-1200.jpg",
  "size": 259142,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T22:48:05Z"
}
